import { render, staticRenderFns } from "./scoreGoods.vue?vue&type=template&id=3cdc6d68"
import script from "./scoreGoods.vue?vue&type=script&lang=js"
export * from "./scoreGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports